import Vue from 'vue'
import Vuex from 'vuex'
import { asyncRoutes, constantRoutes } from '@/router'
Vue.use(Vuex)

// 判断路由权限
const hasPermission = (route, role) => {
  if (route.meta?.role) {
    let roles = route.meta.role
    return roles.includes(role)
  } else {
    return true
  }
}

// 计算异步路由
const filterAsyncRoutes = (routes, role) => {
  let temp = []
  routes.map(v => {
    if (hasPermission(v, role)) {
      if (v.children) {
        v.children = filterAsyncRoutes(v.children, role)
      }
      temp.push(v)
    }
  })
  return temp
}
// 过滤路由
const filterMenu = (routes) => {
  let temp = []
  routes.forEach(v => {
    if (!v.hidden) {
      if (v.children) {
        v.children = filterMenu(v.children)
      }
      temp.push(v)
    }
  });
  return temp
}

export default new Vuex.Store({
  state: {
    tags: [{ title: "首页", path: "/", }],
    LOADING: false,
    role: "",   // 角色
    token: "",   // token
    routes: [], // 左侧菜单需要的路由配置
    isGetUserInfo: false, //是否有用户信息
    accessRoutes: [],
    inputValue:"",   //同步index与indexLast页面v-module
  },
  getters: {

  },
  mutations: {
    showLoading(state) {
      state.LOADING = true;
    },
    hideLoading(state) {
      state.LOADING = false;
    },
    setToken(state, value) {
      state.token = value
    },
    setRole(state, value) {
      state.role = value
    },
    SET_ROUTES(state, data) {
      state.routes = filterMenu([...constantRoutes, ...data])
    },
    SET_IS_GET_USERINFO(state, data) {
      state.isGetUserInfo = data
    },
    setInputValue(state, value) {
      state.inputValue = value
    }
  },
  actions:{
    generateRoutes({commit}, role){
      return  new Promise((resolve, reject) => {
          const accessRoutes = filterAsyncRoutes(asyncRoutes, role)
          commit('SET_ROUTES', accessRoutes)
          resolve(accessRoutes)
      })
   }
  },
  modules: {
  }
})
